import Balloon from "./ballon";

export type { BalloonProps as IBalloon } from "./ballon";

export default Balloon;
